/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import ProductsidProduct from './ProductsidProduct';

/**
 * The ProductsIdBody model module.
 * @module model/ProductsIdBody
 * @version v0.3
 */
export default class ProductsIdBody {
  /**
   * Constructs a new <code>ProductsIdBody</code>.
   * @alias module:model/ProductsIdBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ProductsIdBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ProductsIdBody} obj Optional instance to populate.
   * @return {module:model/ProductsIdBody} The populated <code>ProductsIdBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ProductsIdBody();
      if (data.hasOwnProperty('product'))
        obj.product = ProductsidProduct.constructFromObject(data['product']);
    }
    return obj;
  }
}

/**
 * @member {module:model/ProductsidProduct} product
 */
ProductsIdBody.prototype.product = undefined;

